import { render, staticRenderFns } from "./EndOfYearVoting.vue?vue&type=template&id=06969f5f&scoped=true"
import script from "./EndOfYearVoting.vue?vue&type=script&lang=js"
export * from "./EndOfYearVoting.vue?vue&type=script&lang=js"
import style0 from "./EndOfYearVoting.vue?vue&type=style&index=0&id=06969f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06969f5f",
  null
  
)

export default component.exports